<template>
	<listado></listado>
</template>


<script>

import Listado from './components/listado/listado'

export default {
	name: 'app',
	components: {
		'listado': Listado
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/gestion-anunciantes/vue/App.vue